var _path, _rect, _rect2, _path2, _rect3, _path3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStaceyinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 66,
    viewBox: "0 0 206 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.251 23.944c-4.014-1.371-11.436-2.54-11.754 4.377-.361 7.837 13.212 6.622 12.775 15.202C14.807 52.65 2.92 48.877 1.775 47.8m15.757-24.774h8.403m8.403 0h-8.403m0 0v27.194m7.988-.923l2.281-7.506m13.924 7.506L47.86 41.79m0 0l-5.812-19.227-5.844 19.227m11.656 0H36.204m30.73 6.351c-4.678 2.17-14.036 3.398-14.036-9.049v-5.864c0-15.19 13.39-9.234 13.39-9.234m16.944-.923H71.274v12.42m11.958 13.805H71.274V35.49m0 0h11.08m4.288-12.42l7.889 15.787m0 0l7.948-15.787m-7.948 15.787V63.91m40.584-14.38V22.18l14.616 27.03V4.952m13.441 44.579V22.18m24.288.909h8.235m8.235 0h-8.235m0 0v26.44m-65.682-17.055v7.46c0 3.503-.82 9.596-8.547 9.596-5.832.027-8.695-4.168-8.695-9.596v-7.46c0-4.002 1.075-9.609 8.66-9.609 6.932 0 8.582 4.34 8.582 9.61zm55.73 0v7.46c0 3.503-.82 9.596-8.547 9.596-5.832.027-8.695-4.168-8.695-9.597v-7.459c0-4.002 1.075-9.61 8.66-9.61 6.932 0 8.582 4.34 8.582 9.61z",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.908,
    y: 47.553,
    width: 4.011,
    height: 4.915,
    rx: 1.578,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92.525,
    y: 61.635,
    width: 4.011,
    height: 4.915,
    rx: 1.578,
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M148.545 1.146h.713v1.712h-.713zM150.201 1.146h.713v1.712h-.713z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147.725,
    y: 2.495,
    width: 4.011,
    height: 4.915,
    rx: 1.578,
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M162.018 16.533h.713v1.712h-.713zM163.672 16.533h.713v1.712h-.713z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 161.197,
    y: 17.881,
    width: 4.011,
    height: 4.915,
    rx: 1.578,
    fill: "#000"
  })));
}

export default SvgStaceyinline;